import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';


import HouseholdIncomeField from './IncomeExpenses/HouseholdIncomeField';
import InvestmentIncomeField from './IncomeExpenses/InvestmentIncomeField';

class IncomeFinanceFields extends Component {
    render() {
        return (
            <div>
                <HouseholdIncomeField householdincome={this.props.householdincome} handleChange={this.props.handleChange} onBlur={this.props.validateField} error={this.props.validation.householdincome.isInvalid} errorMessage={this.props.validation.householdincome.message} autoFocus={!isMobile} />   
                <InvestmentIncomeField investmentincome={this.props.investmentincome} handleChange={this.props.handleChange} onBlur={this.props.validateField} error={this.props.validation.investmentincome.isInvalid} errorMessage={this.props.validation.investmentincome.message} />
            </div>
        )
    }
}

IncomeFinanceFields.defaultProps = {
    handleChange: () => { }
};

IncomeFinanceFields.propTypes = {
    handleChange: PropTypes.func,
};

export default IncomeFinanceFields;


// WEBPACK FOOTER //
// ./src/components/Fields/IncomeFinanceFields.js